import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const imgSrc = (url) => {
  if (!url) return "";
  return url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;
};

export const waLink = (settings, message) =>
  `https://wa.me/${(settings?.whatsapp || "").replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;

export const telLink = (settings) => `tel:+${(settings?.phone || "").replace(/\D/g, "")}`;

export const mailLink = (settings) => `mailto:${settings?.email || ""}`;

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return "Something went wrong. Please try again.";
}
